module.exports = __webpack_public_path__ + "img/fulltime.016679a3.png";